<div *ngIf="canRender" class="d-flex align-items-center">
  <mat-error class="mat-caption" *ngIf="errorMessage">{{ errorMessage }}</mat-error>
  <mat-icon *ngIf="canRenderIcon" matSuffix class="mat-error ml-1">error</mat-icon>
</div>
